/**
 * The match modes the list endpoints understand, spelled exactly as they travel in the
 * `filter=<field>,<mode>,<value>` query parameter.
 *
 * There used to be a second vocabulary in front of this one — `equals` / `contains`, the
 * PrimeNG `FilterMatchMode` names the grid layer was originally typed against — translated to
 * these by a `getMatchMode()` in `GridParamService`. PrimeNG is long gone, and the translation
 * outlived it as a trap: its default branch turned anything it did not recognise into `like`,
 * silently. Passing `'eq'` where it wanted `'equals'` compiled, linted, tested and shipped a
 * LIKE query with the underscores escaped. One vocabulary now, and `ParamMatchMode` makes a
 * wrong one a compile error rather than a quiet behaviour change.
 */
export const PARAM_MATCH_MODE = {
    like: 'like',
    equal: 'eq',
    notEqual: 'neq',
    in: 'in',
    startWith: 'startWith'
} as const;

/** Derived from the constant, so the two cannot drift apart. */
export type ParamMatchMode = typeof PARAM_MATCH_MODE[keyof typeof PARAM_MATCH_MODE];
